export const reviewRatingReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_REVIEW_RATING_LIST_REQUEST": {
      return {
        ...state,
        loading: true,
        reviewRatings: null,
      };
    }
    case "GET_REVIEW_RATING_LIST_SUCCESS": {
      return {
        ...state,
        loading: false,
        reviewRatings: action.payload,
      };
    }
    case "GET_REVIEW_RATING_LIST_FAILED": {
      return {
        ...state,
        loading: false,
        reviewRatings: action.payload,
      };
    }
    case "ADD_REVIEW_RATING_REQUEST": {
      return {
        ...state,
        loading: true,
        reviewRating: null,
      };
    }
    case "ADD_REVIEW_RATING_SUCCESS": {
      return {
        ...state,
        loading: false,
        reviewRating: action.payload,
      };
    }
    case "ADD_REVIEW_RATING_FAILED": {
      return {
        ...state,
        loading: false,
        reviewRating: action.payload,
      };
    }
    case "EDIT_REVIEW_RATING_REQUEST": {
      return {
        ...state,
        loading: true,
        reviewRating: null,
      };
    }
    case "EDIT_REVIEW_RATING_SUCCESS": {
      return {
        ...state,
        loading: false,
        reviewRating: action.payload,
      };
    }
    case "EDIT_REVIEW_RATING_FAILED": {
      return {
        ...state,
        loading: false,
        reviewRating: action.payload,
      };
    }
    case "VIEW_REVIEW_RATING_REQUEST": {
      return {
        ...state,
        loading: true,
        singleReviewRating: null,
      };
    }
    case "VIEW_REVIEW_RATING_SUCCESS": {
      return {
        ...state,
        loading: false,
        singleReviewRating: action.payload,
      };
    }
    case "VIEW_REVIEW_RATING_FAILED": {
      return {
        ...state,
        loading: false,
        singleReviewRating: action.payload,
      };
    }
    case "DELETE_REVIEW_RATING_REQUEST": {
      return {
        ...state,
        loading: true,
        reviewRating: null,
      };
    }
    case "DELETE_REVIEW_RATING_SUCCESS": {
      return {
        ...state,
        loading: false,
        reviewRating: action.payload,
      };
    }
    case "DELETE_REVIEW_RATING_FAILED": {
      return {
        ...state,
        loading: false,
        reviewRating: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
